export const ActionTypes={
    SET_PRODUCTS:'SET_PRODUCTS',
    SELECTED_PRODUCT:'SELECTED_PRODUCT',
    REMOVE_SELECTED_PRODUCT:'REMOVE_SELECTED_PRODUCT',
    ADD_FOOD_TO_ORDERS:"ADD_FOOD_TO_ORDERS",
    REMOVE_ALL_ORDERS:"REMOVE_ALL_ORDERS",
    SET_LOGGEDIN_USER:"SET_LOGGEDIN_USER",
    LOG_OUT_USER:'LOG_OUT_USER'
}